import React from "react";

export default function TableAttendance() {
  return <div className="box_table_attendance"></div>;
}
